var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sl-title my-5"},[_vm._v("Name")]),_c('v-card',{attrs:{"flat":""}},[_c('v-list',{staticClass:"py-0",attrs:{"dense":""}},[_c('Fullname'),_c('Preferred')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }